import {validateNumber} from "vuetify/lib/components/VCalendar/util/props"
export default {
    data() {

        return {
            rules: {
                required: [
                    v => (!!v && !Array.isArray(v)) || v === 0 || (Array.isArray(v) && v.length > 0) || 'Field is required',
                ],
                email: [
                    v => !!v || 'E-mail is required',
                    v => new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$').test(v) || 'E-mail must be valid',
                    v => (v && v.length <= 254) || 'Email must be less than 254 characters'
                ],
                emailNotRequired: [
                    v => !v || new RegExp('.+@.+').test(v) || 'E-mail must be valid',
                    v => !v || v.length <= 254 || 'Email must be less than 254 characters'
                ],
                phone: [
                    v => !!v || 'Phone Number is required',
                    v => (v && v.replaceAll('-', '').length === 10) || 'Phone Number must be 10 digits',
                ],
                phoneNotRequired: [
                    v => (v && v.replaceAll('-', '').length === 10) || 'Phone Number must be 10 digits',
                ],
                validNumber: [
                    v => validateNumber(v) || 'Invalid Number is Required'
                ],
                rules: [
                    (value) => !!value || "Required.",
                    (value) => this.isURL(value) || "URL is not valid",
                ],
                select: [(v) => !!v || 'Item is required'],
                credit_card: [
                    value => { return !!(String(value).trim()) || 'Credit Card Number is required' },
                    value => { return (value && value.length >= 12) || 'Credit Card number digits too short' },
                    value => { return (value && value.length >= 12 && value.length <= 16) || 'Maximum length allowed is 16 digits' }
                ],
                expire_month: [
                    value => { return !!(String(value).trim()) || 'Expire Month is required' },
                    value => { return (value && parseInt(value) > 0) || 'Expire Month value must be greater than 0' },
                    value => { return (value && parseInt(value) <= 12) || 'Expire Month must be less than or equal to 12' },
                    value => { return (value && (this.card.expire_year && parseInt(this.card.expire_year) === parseInt((new Date()).getFullYear()) ? (parseInt(value) > (parseInt((new Date()).getMonth()) + 1)): true  ) ) || 'Please check, Expire Year value must be greater than current year for month entered '+value }
                ],
                expire_year: [
                    value => { return !!(String(value).trim()) || 'Expire Year is required' },
                    value => { return (value && parseInt(value) >= parseInt((new Date()).getFullYear()) ) || 'Expire Year must be Current or any next year' },
                    value => { return (value && ( this.card.expire_month && (parseInt(this.card.expire_month) <= (parseInt((new Date()).getMonth()) + 1))? (parseInt(value) > parseInt((new Date()).getFullYear())): true )) || 'Please check, Expire Month value must be greater than current month for year entered '+value }
                ],
                cvv: [
                    value => { return value && !!(String(value).trim()) || 'CVV is required' },
                    value => { return (value && value?.length <= 4) || 'CVV length cannot be more than 4 digits' }
                ],
                zip: [
                    value => { return !!(String(value).trim()) || 'Zip is required' },
                    value => { return (value && value?.length <= 15) || 'Zip length cannot be more than 15 characters' }
                ],
                zipcode: [
                    value => { return !!(String(value).trim()) || 'Zip Code is required' },
                    value => { return /^\d{5}$/.test(value) || 'Zip Code must be exactly 5 digits' }
                ],
                postalCode: [
                    value => { return !!(String(value).trim()) || 'Postal Code is required' },
                    value => { return /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(value) || 'Postal Code must be in format A1A 1A1 or A1A1A1' }
                ]
            }
        }
    },
    methods: {
        requiredLength(length) {

            return [
                ...this.rules.required,
                v => (v && v.length <= length) || 'This field must be no more than ' + length + ' characters long'
            ]
        },
        requireRule(rule) {
            if (this[rule]) {
                return [
                    ...this.rules.required,
                    ...this.rules[rule]
                ]
            } else {
                throw 'Invalid rule'
            }
        },
        isURL(str) {
            let url

            try {
                url = new URL(str)
            } catch (_) {
                return false
            }

            return url.protocol === "http:" || url.protocol === "https:"
        },
    }
    }
